<template>
  <div class="page-404">
    <div class="container">
      <h1>404</h1>
      <h3>The page you're looking for is not here.</h3>
      <router-link :to="{ name: 'Home' }">Back to the home page</router-link>
    </div>
  </div>
</template>
